<template>
  <tbody v-if="opening" class="tbody">
    <tr style="height: 50px">
      <td>{{ opening.clientName }}</td>
      <td>{{ opening.clientEntity }}</td>
      <td>{{ opening.year }}</td>
      <td>{{ opening.currency }} {{ opening.balance }}</td>
      <td>
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Opening Balance ?')"
          @click="deleteBalance(opening._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          :to="'/openingbalance/' + opening._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "OpeningBalanceRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
  },
})
export default class OpeningBalanceRow extends Vue {
  opening = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async deleteBalance(openingbalance_id) {
    common.setLoading(true);
    try {
      await doGet("/api/openingbalance/" + openingbalance_id + "/delete");
      common.showMessage("Deleted Successfully");
      this.$emit("refresh", true);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    if (this.value) {
      this.opening = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.opening = val;
  }

  formatYM(date) {
    if (date) {
      const dateStr = date.toString();
      return dateStr.substring(4, 6) + "-" + dateStr.substring(0, 4);
    } else {
      return "";
    }
  }
}
</script>
